/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { SetStateAction, useEffect, useState } from 'react';
import { Flex, Select } from 'antd';
import { ICountryInfo } from 'interfaces/otherInterface/supportedCountry';
import { LanguageImg } from 'components/ossix/LangComponent';
import { useLanguage } from 'hooks/Language/useLanguage';

const { Option } = Select;

interface CountryDropdownProps {
  countries: ICountryInfo[];
  showDefaultValue?: boolean;
  defaultCountry?: string;
  displayPhoneNumberInput?: boolean;
  setSelectCountry?: React.Dispatch<
    SetStateAction<ICountryInfo | null>
  >;
  loading?: boolean;
  label?: string;
  style?: any;
  className?: any;
  showCountry?: boolean;
  disable?: boolean;
}

interface IDefaultValue {
  CountryCode: string;
  PhoneAreaCode: string;
}

interface CustomDropdownProps {
  countries: ICountryInfo[];
  showDefaultValue?: boolean;
  displayPhoneNumberInput?: boolean;
  handleChange?: (_value: string) => void;
  defaultValue?: string | null;
  loading?: boolean;
  style?: any;
  className?: any;
  disabled?: boolean;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({
  handleChange,
  showDefaultValue,
  defaultValue,
  countries,
  displayPhoneNumberInput,
  loading,
  style,
  className,
  disabled = false,
}: any) => {
  const { translate } = useLanguage();
  return (
    <Select
      showSearch
      loading={loading}
      placeholder={translate('Country')}
      optionFilterProp="children"
      onChange={handleChange}
      size="large"
      value={showDefaultValue ? defaultValue : null}
      style={style}
      className={className}
      disabled={disabled}
    >
      {countries.map((country: ICountryInfo, index: number) => (
        <Option key={index} value={country.CountryCode}>
          <span className="display-row-layout align-row-center">
            <LanguageImg flag={country.Flag} />
            {!displayPhoneNumberInput && (
              <span>{country.CountryName}</span>
            )}
            {displayPhoneNumberInput && (
              <span>{country.CountryCode}</span>
            )}
          </span>
        </Option>
      ))}
    </Select>
  );
};

const CountryDropdown: React.FC<CountryDropdownProps> = ({
  countries,
  showDefaultValue = true,
  displayPhoneNumberInput = false,
  setSelectCountry,
  loading,
  label,
  style,
  className,
  disable,
  defaultCountry,
}) => {
  const [defaultValue, setDefaultValue] =
    useState<IDefaultValue | null>(null);
  const [selectedValue, setSelectedValue] = useState<ICountryInfo>();
  const handleChange = (value: string) => {
    const selectedCountry = countries.find(
      (country: ICountryInfo) => country.CountryCode === value,
    );
    setSelectedValue(selectedCountry);
  };

  const onDefaultValue = (value: IDefaultValue | null) => {
    setDefaultValue(value);
  };

  useEffect(() => {
    if (countries.length || selectedValue) {
      const value: IDefaultValue | null | ICountryInfo | any =
        selectedValue ||
        countries.find((item) => item.CountryCode === defaultCountry);
      onDefaultValue(value);
      setSelectCountry?.(value);
    }
  }, [countries, selectedValue, defaultCountry]);

  return (
    <>
      {displayPhoneNumberInput ? (
        <CustomDropdown
          style={style}
          loading={loading}
          handleChange={handleChange}
          showDefaultValue={showDefaultValue}
          countries={countries}
          displayPhoneNumberInput={displayPhoneNumberInput}
          defaultValue={
            showDefaultValue ? defaultValue?.CountryCode : null
          }
          className={className}
          disabled={disable}
        />
      ) : (
        <Flex
          gap="small"
          vertical
          wrap
          className="small-padding-top"
          style={{ marginBottom: '-20px' }}
        >
          <span style={style}>{label}</span>
          <CustomDropdown
            style={style}
            loading={loading}
            handleChange={handleChange}
            showDefaultValue={showDefaultValue}
            countries={countries}
            displayPhoneNumberInput={displayPhoneNumberInput}
            defaultValue={
              showDefaultValue ? defaultValue?.CountryCode : null
            }
            className={className}
          />
        </Flex>
      )}
    </>
  );
};

export default CountryDropdown;
